// src/graphql/temporary-registration.graphql.ts
import { gql } from '@apollo/client';


export const GET_TEMPORARY_REGISTRATIONS = gql`
  query GetTemporaryRegistrations($status: String, $page: Int, $limit: Int) {
    getTemporaryRegistrations(status: $status, page: $page, limit: $limit) {
      success
      data {
        id
        registrationNo
        patientName
        mobileNumber
        age
        gender
        doctorName
        selectedTests
        status
        expiresAt
        createdAt
      }
      totalCount
    }
  }
`;

export const GET_EXPIRED_TEMPORARY_REGISTRATIONS = gql`
  query GetExpiredTemporaryRegistrations {
    getExpiredTemporaryRegistrations {
      id
      registrationNo
      patientName
      mobileNumber
      expiresAt
    }
  }
`;

export const GET_TEMPORARY_REGISTRATION_STATS = gql`
  query GetTemporaryRegistrationStats {
    getTemporaryRegistrationStats {
      totalDraft
      totalCompleted
      totalExpired
      totalConverted
      conversionRate
      popularTests {
        testName
        count
      }
    }
  }
`;

export const SEND_REMINDER_NOTIFICATION = gql`
  mutation SendReminderNotification($id: ID!) {
    sendReminderNotification(id: $id) {
      success
      message
      sentVia
      error
    }
  }
`;

export const DELETE_TEMPORARY_REGISTRATION = gql`
  mutation DeleteTemporaryRegistration($id: ID!) {
    deleteTemporaryRegistration(id: $id) {
      success
      message
      error
    }
  }
`;

export const CLEANUP_EXPIRED_REGISTRATIONS = gql`
  mutation CleanupExpiredRegistrations {
    cleanupExpiredRegistrations {
      success
      message
      deletedCount
      error
    }
  }
`;

export const CREATE_TEMPORARY_REGISTRATION = gql`
  mutation CreateTemporaryRegistration($input: CreateTemporaryRegistrationInput!) {
    createTemporaryRegistration(input: $input) {
      success
      message
      data {
        id
        registrationNo
        mobileNumber
        patientName
        age
        gender
        email
        doctorName
        prescriptionImage
        extractedData
        selectedTests
        totalAmount
        discountAmount
        finalAmount
        paymentMethod
        membershipId
        membershipVerified
        notes
        status
        expiresAt
        createdAt
        tests {
          id
          testId
          testName
          testCode
          amount
          quantity
          discount
          aiConfidence
          manuallyAdded
        }
      }
      error
    }
  }
`;

export const PROCESS_PRESCRIPTION_AND_SAVE = gql`
  mutation ProcessPrescriptionAndSave($image: String!, $expiresInMinutes: Int) {
    processPrescriptionAndSave(image: $image, expiresInMinutes: $expiresInMinutes) {
      success
      message
      data {
        id
        registrationNo
        mobileNumber
        patientName
        age
        gender
        email
        doctorName
        prescriptionImage
        extractedData
        selectedTests
        totalAmount
        discountAmount
        finalAmount
        paymentMethod
        membershipId
        membershipVerified
        notes
        status
        expiresAt
        createdAt
        tests {
          id
          testId
          testName
          testCode
          amount
          quantity
          discount
          aiConfidence
          manuallyAdded
        }
      }
      error
    }
  }
`;

export const CONVERT_TO_PERMANENT_REGISTRATION = gql`
  mutation ConvertToPermanentRegistration($id: ID!, $customerId: ID) {
    convertToPermanentRegistration(id: $id, customerId: $customerId) {
      success
      message
      registrationId
      registrationNo
      error
    }
  }
`;

export const UPDATE_TEMPORARY_REGISTRATION = gql`
  mutation UpdateTemporaryRegistration($input: UpdateTemporaryRegistrationInput!) {
    updateTemporaryRegistration(input: $input) {
      success
      message
      data {
        id
        registrationNo
        mobileNumber
        patientName
        age
        gender
        email
        doctorName
        selectedTests
        totalAmount
        discountAmount
        finalAmount
        paymentMethod
        membershipId
        membershipVerified
        notes
        status
      }
      error
    }
  }
`;

export const GET_TEMPORARY_REGISTRATION = gql`
  query GetTemporaryRegistration($id: ID!) {
    getTemporaryRegistration(id: $id) {
      success
      data {
        id
        registrationNo
        mobileNumber
        patientName
        age
        gender
        email
        doctorName
        prescriptionImage
        extractedData
        selectedTests
        totalAmount
        discountAmount
        finalAmount
        paymentMethod
        membershipId
        membershipVerified
        notes
        status
        expiresAt
        createdAt
        tests {
          id
          testId
          testName
          testCode
          amount
          quantity
          discount
          aiConfidence
          manuallyAdded
        }
        aiLogs {
          id
          confidenceScore
          processingTimeMs
          modelUsed
          status
          createdAt
        }
      }
      error
    }
  }
`;

export const GET_TEMPORARY_REGISTRATION_BY_MOBILE = gql`
  query GetTemporaryRegistrationByMobile($mobile: String!) {
    getTemporaryRegistrationByMobile(mobile: $mobile) {
      success
      data {
        id
        registrationNo
        mobileNumber
        patientName
        age
        gender
        status
        expiresAt
        createdAt
      }
      totalCount
      error
    }
  }
`;

// export const SEND_REMINDER_NOTIFICATION = gql`
//   mutation SendReminderNotification($id: ID!) {
//     sendReminderNotification(id: $id) {
//       success
//       message
//       sentVia
//       error
//     }
//   }
// `;

// export const CLEANUP_EXPIRED_REGISTRATIONS = gql`
//   mutation CleanupExpiredRegistrations {
//     cleanupExpiredRegistrations {
//       success
//       message
//       deletedCount
//       error
//     }
//   }
// `;